import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import * as AuthActions from 'src/app/store/auth/auth.actions';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import * as NotificationsActions from "src/app/store/notifications/notifications.actions";
import { TokenData } from 'src/app/model/api/token-data';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-helper-view-clients',
	templateUrl: './helper-view-clients.component.html',
	changeDetection: ChangeDetectionStrategy.Default,
	providers: [DialogService]
})

export class HelperViewClientsComponent implements OnInit {
	// Observables and subscriptions
	tokenData: TokenData;
	tokenSave: TokenData;

	appid: string;

	ref: DynamicDialogRef | undefined;

	constructor(
		private store: Store<AppState>,
		public dialogService: DialogService,
		private formBuilder: FormBuilder,
		private route: ActivatedRoute,
		private router: Router,
	) {
		// this.initSelectors();
	}

	ngOnInit() {
		this.store.dispatch(NotificationsActions.setTopbarTitleId({
			stringId: 'HELPER'
		}));

		const appid = this.route.snapshot.queryParamMap.get('appid');
		this.appid = appid;

		const token = this.route.snapshot.queryParamMap.get('token');

		// !! PAY ATTENTION
		// for guest appid without token (for example intercomsetup)
		// we need to exclude the appid URL string from authLogout$ in auth.effects
		// we need to exclude the auto direct on Login page
		if (appid !== 'intercomsetup') {
			this.tokenData = {
				access_token: token,
				expires_in: 7000,
				refresh_token: '',
				token_type: 'bearer',
				error: null,
			};
			this.store.dispatch(AuthActions.getHelpToken({ tokenData: this.tokenData }));
		}
	}

}